export const translations = {
  PAGINATION: {
    sv: 'Paginering',
    en: 'Pagination',
    da: 'Paginering',
    fi: 'Sivunumerointi',
    no: 'Paginering',
  },
  PAGE: {
    sv: 'Sida',
    en: 'Page',
    da: 'Side',
    fi: 'Sivu',
    no: 'Side',
  },
  PREVIOUS_PAGE: {
    sv: 'Föregående sida',
    en: 'Previous page',
    da: 'Forrige side',
    fi: 'Edellinen sivu',
    no: 'Forrige side',
  },
  NEXT_PAGE: {
    sv: 'Nästa sida',
    en: 'Next page',
    da: 'Næste side',
    fi: 'Seuraava sivu',
    no: 'Neste side',
  },
  ROWS_PAGE: {
    sv: 'Object per sida',
    en: 'Items per page',
    da: 'Varer pr. side',
    fi: 'Kohteita per sivu',
    no: 'Elementer per side',
  },
};
